const development: boolean = process.env.NODE_ENV === 'development';

export class EnvHelper {

    static get isDev(): boolean {
        return development;
    }
}